
































import { Vue, Component } from 'vue-property-decorator';
import PostWriter from './PostWriter.vue';
import Layout from './Layout.vue';
import Post from './Post.vue';
import PostSearch from './PostSearch.vue';
import { vxm } from '@/store.vuex';
import SectionTitle from '@/components/Commons/SectionTitle.vue';
import WelcomeForum from './WelcomeForum.vue';
import NoResultForum from './NoResultForum.vue';
@Component({
  components: {
    PostWriter,
    Layout,
    Post,
    PostSearch,
    SectionTitle,
    WelcomeForum,
    NoResultForum,
  },
})
export default class Main extends Vue {
  private searchText = '';
  private selectedCategoryId = -1;

  mounted() {
    vxm.forum.loadPosts({ initCall: true });
    vxm.forum.fetchReportReasons();
    vxm.forum.fetchCategories();
  }

  get busy() {
    return vxm.forum.Busy;
  }

  get postList() {
    return vxm.forum.PostList;
  }

  get canShowForumWelcomePage() {
    return (
      !this.postList.length &&
      !this.searchText &&
      !this.busy &&
      this.selectedCategoryId === -1
    );
  }

  async loadPosts() {
    if (this.postList.length) {
      await vxm.forum.loadPosts({
        allCategories: this.selectedCategoryId,
        searchVal: this.searchText,
      });
    }
  }

  private onSearch = this.lodash.debounce((searchVal, categoryId) => {
    vxm.forum.loadPosts({
      initCall: true,
      searchVal,
      allCategories: categoryId,
    });
  }, 1000);

  onForumSearch(text) {
    vxm.forum.setBusy(true);
    this.onSearch(text, this.selectedCategoryId);
    this.searchText = text;
  }

  onUpdateCategory(id) {
    this.selectedCategoryId = id;
    vxm.forum.loadPosts({
      initCall: true,
      allCategories: this.selectedCategoryId,
      searchVal: this.searchText,
    });
  }
}
